import { render, staticRenderFns } from "./push-button.vue?vue&type=template&id=45179624&"
import script from "./push-button.vue?vue&type=script&lang=js&"
export * from "./push-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports